'use strict';

var _objectSpread = require("/vercel/path0/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
module.exports = function (string) {
  var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var options = arguments.length > 2 ? arguments[2] : undefined;
  options = _objectSpread({
    indent: ' ',
    includeEmptyLines: false
  }, options);
  if (typeof string !== 'string') {
    throw new TypeError("Expected `input` to be a `string`, got `".concat(typeof string, "`"));
  }
  if (typeof count !== 'number') {
    throw new TypeError("Expected `count` to be a `number`, got `".concat(typeof count, "`"));
  }
  if (typeof options.indent !== 'string') {
    throw new TypeError("Expected `options.indent` to be a `string`, got `".concat(typeof options.indent, "`"));
  }
  if (count === 0) {
    return string;
  }
  var regex = options.includeEmptyLines ? /^/gm : /^(?!\s*$)/gm;
  return string.replace(regex, options.indent.repeat(count));
};